import { L } from 'stroly-js';

import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  inject,
} from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';

import { TranslateService } from '@ngx-translate/core';

import { ToolbarComponent } from './dashboard/ui/components/toolbar/toolbar.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ToolbarComponent, RouterOutlet],
})
export class AppComponent {
  // Inject services
  private readonly router = inject(Router);
  private readonly cd = inject(ChangeDetectorRef);
  private readonly translate = inject(TranslateService);

  title = 'stroly-dashboard';
  locationPathname = '';
  isMobile =
    L.Browser.mobile &&
    !sessionStorage.getItem('enablePCMode') &&
    window.parent.screen.width < 1024 &&
    !(
      window.parent.screen.height >= 1024 &&
      window.orientation.toString().indexOf('90') != -1
    );
  language =
    (window.navigator.languages && window.navigator.languages[0]) ||
    window.navigator.language;

  // 翻訳済みテキスト
  helpGuide = '';
  terms = '';
  privacyPolicy = '';
  operatingCompany = '';

  constructor() {
    // zone.onMicrotaskEmpty.subscribe(() => {
    //   this.locationPathname = location.pathname;
    //   console.log(location.pathname, "detect change");
    // });
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.locationPathname = event.url;
        this.cd.markForCheck();
      }
    });

    this.translate.setDefaultLang('en');
    this.translate.addLangs(['en', 'ja']);
    const lang = this.translate.getBrowserLang()?.includes('ja') ? 'ja' : 'en';
    this.translate.use(lang);

    this.translate
      .get([
        'toolbar.HelpGuide',
        'toolbar.Terms',
        'toolbar.PrivacyPolicy',
        'toolbar.OperatingCompany',
      ])
      .subscribe((translations) => {
        this.helpGuide = translations['toolbar.HelpGuide'];
        this.terms = translations['toolbar.Terms'];
        this.privacyPolicy = translations['toolbar.PrivacyPolicy'];
        this.operatingCompany = translations['toolbar.OperatingCompany'];
      });
  }

  ngOnInit(): void {
    if (!this.isMobile) {
      document
        .getElementsByTagName('app-root')[0]
        .setAttribute('style', 'min-width: 1400px');
    } else {
      // ダブルタップによる拡大操作無効化
      let lastTouch = 0;
      document.addEventListener(
        'touchend',
        (event) => {
          const now = window.performance.now();
          if (now - lastTouch <= 500) {
            event.preventDefault();
          }
          lastTouch = now;
        },
        true,
      );
    }
  }
}
